export function MyError(c, m) {
  this.code = c
  this.message = m
}
